import SubmitAnswers from "./SubmitAnwers";

export default SubmitAnswers;
